import CampaignSurvey from "../../api/Survey/CampaignSurvey";

export const getSurvey = async (campaignId: string, surveyId: string, profileGuid: string, languageId: number) => {
    return await CampaignSurvey.getSurvey(campaignId, surveyId, profileGuid, languageId);
}
